import React from 'react';

interface IAppointmentsContext {
  date: Date | null;
  setFilter: (
    date: Date | null,
  ) => void;
}

const AppointmentsContext = React.createContext<IAppointmentsContext>({
  date: null,
  setFilter: () => {},
});

export default AppointmentsContext;
